module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-info-bd85581e99b46ae55d54f73fdc35d372.svg";